import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing[5]}px;

  @media (max-width: 998px) {
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[3]}px;
  }
`;

export const ContainerDetalhamentoValores = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]}px;

  @media (min-width: 998px) {
    flex-wrap: wrap;
  }
`;

export const ContainerLinhaBotoes = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;
